import ColorPickerInput from './color-picker-input.vue';
export default ColorPickerInput;


// WEBPACK FOOTER //
// ./src/components/color-picker-input/index.js